import { HEADER_HEIGHT_S, scale } from "@capioweb/ui-components/src"

export const scrollToAnchor = (el: HTMLElement) => {
	window.scrollTo(0, el.offsetTop)
	setTimeout(() => {
		const headerOffset = scale(HEADER_HEIGHT_S) + 10
		const elementPosition = el.offsetTop
		const offsetPosition = elementPosition - headerOffset

		window.scrollTo({
			top: offsetPosition,
			behavior: "smooth",
		})
	}, 100)
}
